// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__18123","boxTitle":"Qualiphy_boxTitle__3dx6m","box":"Qualiphy_box__2dMqE","toggleWrap":"Qualiphy_toggleWrap__2DaTR"};